import { useRouterState } from '@tanstack/react-router';
import { pathSegmentName } from '../page-name.ts';

// The matched leaf route's `fullPath` (e.g. `/features/documents`). Params stay
// placeholders (`/documents/$id`), so it's low-cardinality.
export function useRouteFullPath(): string {
  return useRouterState({
    select: (s) => s.matches[s.matches.length - 1]?.fullPath ?? s.location.pathname,
  });
}

// That route as a `data-gp-name` segment. Stamped on `<main>`, so every element
// gets a page-scoped path and no page names itself.
export function useRouteName(): string {
  return pathSegmentName(useRouteFullPath());
}
